import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { buildTabsItems } from './FormHelpers'
import { Tabs } from 'antd'

const Form = () => {
  const { t } = useTranslation('legalFormalities')
  const { legalFormality } = useContext(CurrentLegalFormalityContext)

  return (
    <>
      <Tabs
        defaultActiveKey="customer"
        items={buildTabsItems(t, legalFormality)}
      />
    </>
  )
}

export default Form
